var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainContentDiv',{staticClass:"pa-20"},[_vm._v(" 已废弃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }